import React from 'react'
import EORCalculator from '../components/EORCalculator'
import { useNavigate, useParams } from 'react-router-dom';
import Hero from '../components/Hero';
import Display from '../components/Display';

const EORcalculation = () => {
    const { countryName } = useParams(); // Extract the dynamic part of the URL
    const navigate = useNavigate();
  return (
  <>
   <Hero
      title="Plan Smarter,Not Harder - Start Calculating Today!."
      description="Quickly calculate your costs with our easy-to-use tool. Get clear estimates and make smarter decisions in no time."
      buttonText="Explore More"
      customClass = "costcal-banner"
      buttonBgColor="hero-button-bg-color"
      imageSrc="/images/calban.webp"
      squareColor="square-bg-color"
      onButtonClick={() => navigate('meet-the-experts')}
    />
  <EORCalculator countryName={countryName}/>
  <Display/>
  </>
  )
}

export default EORcalculation